module.exports = __webpack_public_path__ + "static/media/04A.fa078bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/04A.png
// module id = 252
// module chunks = 0